import {
  SET_HOME_FILTERS,
  SET_HOME_QUERY,
  SHOW_DATE_TIME_MODAL,
  HIDE_DATE_TIME_MODAL,
  SHOW_LOGISTICS_MODAL,
  HIDE_LOGISTICS_MODAL,
  RESTAURANT_LOCATION_SEARCH_SUCCESS,
} from '../../actions/types';

const initialState = {
  location: {
    geohash: '',
    postcode: '',
    city: '',
    neighborhood: '',
  },
  fulfillmentMethod: '',
  fulfillmentTime: '',
  deliveryTime: '',
  selectedFilters: {},
  query: '',
  showDateTimeModal: false,
  showLogisticsModal: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_HOME_FILTERS:
      return {
        ...state,
        collection: action.payload.collection,
        location: {
          geohash: action.payload.geohash,
          postcode: action.payload.postcode,
          city: action.payload.city,
          neighborhood: action.payload.neighborhood,
        },
        fulfillmentMethod: action.payload.fulfillmentMethod,
        deliveryTime: action.payload.deliveryTime,
        fulfillmentTime: action.payload.fulfillmentTime,
        selectedFilters: action.payload.selectedFilters,
        query: action.payload.query,
      };
    case SET_HOME_QUERY:
      return {
        ...state,
        query: action.payload.query,
      };
    case SHOW_DATE_TIME_MODAL:
      return {
        ...state,
        showDateTimeModal: true,
      };
    case HIDE_DATE_TIME_MODAL:
      return {
        ...state,
        showDateTimeModal: false,
      };
    case SHOW_LOGISTICS_MODAL:
      return {
        ...state,
        showLogisticsModal: true,
      };
    case HIDE_LOGISTICS_MODAL:
    case RESTAURANT_LOCATION_SEARCH_SUCCESS:
      return {
        ...state,
        showLogisticsModal: false,
      };
    default:
      return state;
  }
}
